export const SET_REGION_SUCCESS = "SET_REGION_SUCCESS";

export const FETCH_SECTIONS = "FETCH_SECTIONS";
export const FETCH_SECTIONS_SUCCESS = "FETCH_SECTIONS_SUCCESS";
export const FETCH_SECTIONS_FAILURE = "FETCH_SECTIONS_FAILURE";

export const FETCH_METADATA = "FETCH_METADATA";
export const FETCH_METADATA_SUCCESS = "FETCH_METADATA_SUCCESS";
export const FETCH_METADATA_FAILURE = "FETCH_METADATA_FAILURE";

export const FETCH_EVENTS = "FETCH_EVENTS";
export const FETCH_EVENTS_SUCCESS = "FETCH_EVENTS_SUCCESS";
export const FETCH_EVENTS_FAILURE = "FETCH_EVENTS_FAILURE";

export const POST_EVENT = "POST_EVENT";
export const POST_EVENT_SUCCESS = "POST_EVENT_SUCCESS";
export const POST_EVENT_FAILURE = "POST_EVENT_FAILURE";

export const DELETE_EVENT = "DELETE_EVENT";
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_FAILURE = "DELETE_EVENT_FAILURE";